import {ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {State} from '../../../store/user/user.reducers';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../store/app.reducers';
import {takeUntil} from 'rxjs/operators';
import {TranslatePipe} from '@ngx-translate/core';
import {GTC_FILENAMES_MAP} from '../../../misc/utils';

@Component({
  selector: 'ucs-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe]
})

export class TermsComponent implements OnInit, OnDestroy {
  userState: State;
  private store = inject<Store<fromRoot.AppState>>(Store);
  private unsubscribe: Subject<void> = new Subject<void>();

  /**
   * Called when component is being initialized.
   */
  ngOnInit(): void {
    // subscribe to user state to access the user's roles
    this.store.select(fromRoot.getUserState)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(userState => {
        if (userState) {
          this.userState = userState;
        }
      });
  }

  getGTCFile(distributionChannel: DistributionChannel, country: Country): string[] {
    const result = GTC_FILENAMES_MAP.get(distributionChannel).get(country);
    if (result === undefined) {
      return ['GTC_Placeholder_en.pdf'];
    }
    return result;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
